export default __webpack_public_path__ + "static/media/wdg-img-3.01fca84c.jpg";